(()=>{
  if(window.TwoInOneFlagSearch)return;
  const lib=window.__2in1FlagLibrary;
  if(!lib)return;
  const {CDN,SPORTS,SOCCER_FILES,COUNTRY_ALIASES,clubLabel,sportsFile}=lib;
  const DRAFT_KEY='2in1flags:design:draft:v1';
  const PRODUCTS=[
    {id:'flag',label:'Flag',handle:'double-sided-custom-flag-2in1flags-logo-outdoor-banner',keys:'flag banner'},
    {id:'tee',label:'T-Shirt',handle:'unisex-custom-flag-t-shirt',keys:'tee tshirt t-shirt shirt'},
    {id:'hoodie',label:'Hoodie',handle:'2in1flags-logo-hoodie-eco-friendly-pullover-sweatshirt',keys:'hoodie'},
    {id:'ziphoodie',label:'Zip Hoodie',handle:'2-in-1-flags-zip-hoodie-puerto-rico-texas-flag-mashup',keys:'zip hoodie zip-up zipup'},
    {id:'sweatshirt',label:'Sweatshirt',handle:'youth-crewneck-sweatshirt',keys:'sweatshirt sweater jumper crewneck'},
    {id:'hat',label:'Hat',handle:'dad-hat',keys:'hat cap dad'},
    {id:'mug',label:'Mug',handle:'custom-flag-mug',keys:'mug cup'},
    {id:'tote',label:'Tote Bag',handle:'custom-flag-tote-bag',keys:'tote bag'}
  ];
  const HINTS=[
    {label:'Ireland',query:'Ireland'},
    {label:'Jamaica',query:'Jamaica'},
    {label:'Yankees',query:'Yankees'},
    {label:'hoodie',query:'hoodie'}
  ];

  const norm=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  const escapeHtml=value=>String(value||'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));

  const countries=(()=>{
    const list=(lib.countries||[]).map(item=>({
      kind:'flag',
      type:'country',
      value:item.value,
      label:item.label,
      hay:norm(item.label),
      thumb:`https://flagcdn.com/w80/${item.value}.png`,
      thumbLarge:`https://flagcdn.com/w320/${item.value}.png`,
      meta:'Country'
    }));
    return list.length?list:[{kind:'flag',type:'country',value:'us',label:'United States',hay:'united states',thumb:'https://flagcdn.com/w80/us.png',thumbLarge:'https://flagcdn.com/w320/us.png',meta:'Country'}];
  })();

  const teams=[];
  Object.entries(SPORTS).forEach(([league,list])=>{
    list.forEach(label=>{
      const file=sportsFile(league,label);
      const url=`${CDN}${file}.png`;
      teams.push({kind:'flag',type:'sports',value:file,label,hay:norm(label),thumb:url,thumbLarge:url,meta:league});
    });
  });
  SOCCER_FILES.forEach(base=>{
    const label=clubLabel(base);
    const file=`${base}_5000_5500`;
    const url=`${CDN}${file}.png`;
    teams.push({kind:'flag',type:'sports',value:file,label,hay:norm(label),thumb:url,thumbLarge:url,meta:'Football'});
  });
  const flags=[...countries,...teams];

  function scoreFlag(item,query){
    const q=norm(query);
    if(!q)return 0;
    if(item.type==='country'&&COUNTRY_ALIASES[q]===item.value)return 96;
    if(item.type==='country'&&item.value===q)return 94;
    if(item.hay===q)return 100;
    if(item.hay.startsWith(q))return 82;
    const words=item.hay.split(' ');
    if(words.some(word=>word===q))return 78;
    if(item.hay.includes(` ${q} `)||item.hay.endsWith(` ${q}`))return 74;
    if(words.some(word=>word.startsWith(q)))return 62;
    if(item.hay.includes(q))return 54;
    return 0;
  }

  function bestFlags(query,limit=8){
    return flags.map(item=>({item,score:scoreFlag(item,query)}))
      .filter(entry=>entry.score>=54)
      .sort((a,b)=>b.score-a.score||a.item.label.localeCompare(b.item.label))
      .slice(0,limit)
      .map(entry=>Object.assign({},entry.item,{score:entry.score}));
  }

  function bestFlag(query){
    const [hit]=bestFlags(query,1);
    return hit&&hit.score>=62?hit:null;
  }

  function findPair(query){
    const raw=String(query||'').trim();
    if(!raw)return null;
    const whole=bestFlag(raw);
    if(whole&&whole.score>=78)return null;
    const parts=raw.split(/\s*(?:\+|\/|&|,|\band\b)\s*/i).map(part=>part.trim()).filter(Boolean);
    if(parts.length>=2){
      const left=bestFlag(parts[0]);
      const right=bestFlag(parts[1]);
      if(left&&right&&left.value!==right.value)return [left,right];
    }
    const words=norm(raw).split(' ').filter(Boolean);
    if(words.length<2)return null;
    let best=null;
    for(let i=1;i<words.length;i++){
      const left=bestFlag(words.slice(0,i).join(' '));
      const right=bestFlag(words.slice(i).join(' '));
      if(!left||!right||left.value===right.value)continue;
      const total=left.score+right.score;
      if(left.score>=62&&right.score>=62&&(!best||total>best.score))best={items:[left,right],score:total};
    }
    return best?.items||null;
  }

  function productUrl(product,root){
    const custom=root?.dataset[`product${product.id}`];
    return custom||`/products/${product.handle}`;
  }

  function scoreProduct(product,query){
    const q=norm(query);
    if(!q)return 0;
    const hay=norm(`${product.label} ${product.keys}`);
    if(norm(product.label)===q)return 100;
    if(hay.split(' ').includes(q))return 86;
    if(hay.startsWith(q)||norm(product.label).startsWith(q))return 74;
    if(hay.includes(q))return 60;
    return 0;
  }

  function bestProducts(query,limit=4){
    return PRODUCTS.map(item=>({item,score:scoreProduct(item,query)}))
      .filter(entry=>entry.score>=60)
      .sort((a,b)=>b.score-a.score)
      .slice(0,limit)
      .map(entry=>entry.item);
  }

  function pairingFromItems(items){
    const list=(items||[]).filter(item=>item&&item.value).slice(0,4).map(item=>({
      type:item.type==='sports'?'sports':'country',
      value:String(item.value),
      name:item.label||item.name||''
    }));
    if(!list.length)return null;
    const count=list.length;
    const cross=count<=1?'single':count===2?'vertical':count===3?'t-top':'quadrant';
    const padded=Array.from({length:4},(_,index)=>list[index]||{...list[0]});
    const side={count,cross,split:'line',lineSize:16,lineColor:'#087df5',items:padded};
    return {version:1,updatedAt:new Date().toISOString(),front:JSON.parse(JSON.stringify(side)),back:JSON.parse(JSON.stringify(side)),side:'front'};
  }

  function encodeFlags(items){
    return items.map(item=>item.type==='sports'?`s:${item.value}`:`c:${item.value}`).join('|');
  }

  function designerUrl(items,home){
    const url=new URL(home||'/',window.location.origin);
    url.searchParams.set('scroll','designer');
    url.searchParams.set('flags',encodeFlags(items));
    return url.toString();
  }

  function searchUrl(query,base){
    const url=new URL(base||'/search',window.location.origin);
    url.searchParams.set('q',String(query||'').trim());
    return url.toString();
  }

  function openDesigner(items,home){
    const design=pairingFromItems(items);
    if(!design)return;
    try{localStorage.setItem(DRAFT_KEY,JSON.stringify(design));}catch(_){}
    if(document.querySelector('[data-hfd]')){
      document.dispatchEvent(new CustomEvent('2in1:apply-search-flags',{detail:{items}}));
      return;
    }
    window.location.assign(designerUrl(items,home));
  }

  function resultsFor(query,flagLimit=24,productLimit=8){
    const q=String(query||'').trim();
    const pair=findPair(q);
    const flagHits=bestFlags(q,flagLimit);
    if(pair){
      pair.slice().reverse().forEach(item=>{
        if(!flagHits.some(hit=>hit.value===item.value))flagHits.unshift(item);
      });
    }
    return {query:q,pair,flags:flagHits,products:bestProducts(q,productLimit)};
  }

  function articleImage(item){
    if(!item)return '';
    if(typeof item.image==='string')return item.image;
    return item.image?.url||item.image?.src||item.featured_image||'';
  }

  function articleBlog(item){
    if(item?.blog&&typeof item.blog==='object'&&item.blog.title)return item.blog.title;
    if(typeof item?.blog==='string'&&item.blog)return item.blog;
    const match=String(item?.url||'').match(/\/blogs\/([^/]+)/);
    if(!match)return 'Blog';
    return match[1].replace(/[-_]+/g,' ').replace(/\b\w/g,char=>char.toUpperCase());
  }

  function normalizeArticle(item){
    return {
      type:'article',
      title:item?.title||'',
      url:item?.url||'',
      image:articleImage(item),
      blog:articleBlog(item),
      excerpt:String(item?.excerpt||item?.summary_html||item?.body||'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim().slice(0,140),
      tags:Array.isArray(item?.tags)?item.tags.join(' '):String(item?.tags||'')
    };
  }

  function catalogArticles(){
    if(Array.isArray(window.__hfsArticles))return window.__hfsArticles;
    const node=document.querySelector('[data-hfs-articles]');
    try{
      window.__hfsArticles=(JSON.parse(node?.textContent||'[]')||[]).map(normalizeArticle).filter(item=>item.title&&item.url);
    }catch(_){
      window.__hfsArticles=[];
    }
    return window.__hfsArticles;
  }

  function scoreArticle(article,query){
    const q=norm(query);
    if(!q)return 0;
    const title=norm(article.title);
    const hay=norm(`${article.title} ${article.tags} ${article.excerpt} ${article.blog}`);
    if(title===q)return 100;
    if(title.startsWith(q))return 84;
    if(title.split(' ').includes(q))return 80;
    if(title.includes(q))return 74;
    const words=q.split(' ').filter(word=>word.length>2);
    if(words.length>1&&words.every(word=>hay.includes(word)))return 70;
    if(hay.split(' ').includes(q))return 66;
    if(hay.includes(q))return 58;
    return 0;
  }

  function bestArticles(query,limit=4){
    return catalogArticles().map(item=>({item,score:scoreArticle(item,query)}))
      .filter(entry=>entry.score>=58)
      .sort((a,b)=>b.score-a.score||a.item.title.localeCompare(b.item.title))
      .slice(0,limit)
      .map(entry=>entry.item);
  }

  function mergeArticles(primary,secondary,limit=6){
    const seen=new Set();
    const out=[];
    for(const item of [...(primary||[]),...(secondary||[])]){
      const key=String(item?.url||item?.title||'').toLowerCase();
      if(!key||seen.has(key))continue;
      seen.add(key);
      out.push(item);
      if(out.length>=limit)break;
    }
    return out;
  }

  function suggestArticlesUrl(query,limit=4,root){
    const raw=(root?.dataset.suggest||window.routes?.predictive_search_url||'/search/suggest').replace(/\.json$/,'');
    const params=new URLSearchParams({
      q:query,
      'resources[type]':'article',
      'resources[limit]':String(limit),
      'resources[limit_scope]':'each',
      'resources[options][fields]':'title,body,tag'
    });
    return `${raw}.json?${params.toString()}`;
  }

  async function fetchArticles(query,limit=4,options={}){
    const q=String(query||'').trim();
    if(!q)return [];
    const response=await fetch(suggestArticlesUrl(q,limit,options.root),{
      signal:options.signal,
      headers:{Accept:'application/json'}
    });
    if(!response.ok)return [];
    const data=await response.json();
    return (data.resources?.results?.articles||[]).map(normalizeArticle).filter(item=>item.title&&item.url);
  }

  window.TwoInOneFlagSearch={
    HINTS,
    PRODUCTS,
    escapeHtml,
    bestFlags,
    bestFlag,
    findPair,
    bestProducts,
    bestArticles,
    normalizeArticle,
    mergeArticles,
    fetchArticles,
    productUrl,
    pairingFromItems,
    encodeFlags,
    designerUrl,
    searchUrl,
    openDesigner,
    resultsFor
  };
})();
